import React from 'react';
import { Paper, Typography, Grid, useTheme } from '@mui/material';

/**
 * Standard stat cards used at the top of queue pages.
 *
 * Props:
 *   stats:    object — { pending, processing, completed, failed }
 *   fallback: object — same shape, derived client-side from the jobs
 *             array. Used when stats is null/loading so the cards
 *             never show 0/0/0/0 despite a populated table beneath.
 */
export default function StatCards({ stats, fallback }) {
  const theme = useTheme();
  const src = stats || fallback || {};
  const cards = [
    { label: 'Pending', value: src.pending || 0, color: theme.palette.info.main },
    { label: 'Processing', value: src.processing || 0, color: theme.palette.warning.main },
    { label: 'Completed', value: src.completed || 0, color: theme.palette.success.main },
    { label: 'Failed', value: src.failed || 0, color: theme.palette.error.main },
  ];
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid size={{ xs: 6, sm: 3 }} key={card.label}>
          <Paper sx={{ p: 2, textAlign: 'center', borderTop: `3px solid ${card.color}` }}>
            <Typography variant="h4" fontWeight={700} sx={{ color: card.color }}>{card.value}</Typography>
            <Typography variant="body2" color="text.secondary">{card.label}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
